import { render, staticRenderFns } from "./PreviewSetup.vue?vue&type=template&id=8dc287dc&scoped=true&"
import script from "./PreviewSetup.vue?vue&type=script&lang=js&"
export * from "./PreviewSetup.vue?vue&type=script&lang=js&"
import style0 from "./PreviewSetup.vue?vue&type=style&index=0&id=8dc287dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc287dc",
  null
  
)

export default component.exports